import { logger } from '../../../../../utils/common/logger'
import { LoginService } from '../services/login-service'
import { LoginRadiusWidget, LRWidgetType } from './base'

export interface ISuccessResponse {
    Profile: any,
    Data: any,
    access_token: string,
    jwttoken: string
}

export class LoginWidget extends LoginRadiusWidget {

    constructor(container: string, lrObject: any) {
        super()
        this.widgetType = LRWidgetType.LOGIN
        this.lrObject = lrObject
        this.container = container
        logger('info', 'login widget created')
    }

    protected async onSuccess(response: ISuccessResponse) {
        logger('info', 'Successfully logged in: ', response)
        LoginService.clearErrors()
        await LoginService.handleLoginSuccess(response)
    }

    protected onError(errors: any) {
        logger('error', errors)
        // Remove 'loading' class from the submit button and enable it
        const submitButton = document.getElementById('loginradius-submit-login') as HTMLInputElement
        if (submitButton) {
            submitButton.classList.remove('loading')
            submitButton.removeAttribute('disabled')
        }
        LoginService.clearErrors()
        LoginService.showErrors(errors)
        LoginService.sendSubmissionErrorAnalytics(errors, 'login')
    }
}
